'use strict';

const mixin = {
  props: {
    title: {
      type: String
    },
    embed: {
      type: Boolean
    },
    year: {
      type: String
    },
    device: {
      type: String
    },
    showDisclaimer: {
      type: Boolean,
      default: true,
    },
    includeYearInTitle: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      currentYear: this.year || this.$store.state.currentYear,
      isApp: Boolean(window.DNA_APP_ENV || document.querySelector('.screenkit--embed-container')),
    };
  },
  mounted() {
    console.log('eui-core-embed-mixin');
  },
  computed: {
    isMobile() {
      return Boolean(this.device?.match('mobile'));
    },
    electionYears() {
      return Object.keys(this.$store.state.elections) || [this.currentYear];
    },
    titleText() {
      if (!this.title) return;
      const label = this.$store.getters.currentElection(this.currentYear).year;
      return this.currentYear && this.includeYearInTitle && this.electionYears?.length > 1 ? `${ this.title } - ${ label }` : this.title;
    },
    titleProps() {
      return {
        title: this.titleText,
        fineprint: this.percentCounted,
        isLive: this.isLive,
      };
    },
    percentCounted() {
      const percentRollCounted = this.$store.getters.percentCounted(this.currentYear);
      return percentRollCounted ? `${ percentRollCounted }% counted` : null;
    },
    debug() {
      return (window.debugElection || window.location.search.match('debugElection')) ? this.$store.getters.debug() : null;
    },
    error() {
      return this.$store.getters.error();
    },
    loading() {
      // return true;

      const { loading, summaryLoading, mapLoading } = this.$store.state;
      return loading || summaryLoading || mapLoading;
    },
    isLive() {
      return this.$store.getters.currentElection(this.currentYear).live;
    },
    disclaimerConfig() {
      if (!this.showDisclaimer) return null;

      const currentElection = this.$store.getters.currentElection(this.currentYear);
      const isSuperVoter = currentElection.year === 'supervoter';

      // Hide "See all live results" when no disclaimer config is present
      const indexPageDomain = this.$store.getters.getIndexPageDomain();
      const indexPageUrl = this.$store.getters.getIndexPageUrl();
      const indexAbsLink = indexPageDomain && indexPageUrl ? `${ indexPageDomain }${ indexPageUrl }` : '';
      return {
        text: currentElection.disclaimer,
        link: isSuperVoter ? `${ indexAbsLink }&supervoter` : currentElection.disclaimerLink,
        linkText: currentElection.disclaimerLinkText,
        indexLink: this.embed ? indexAbsLink : '',
      };
    },
  },
  watch: {
    year(year, oldYear) {
      console.log(year, oldYear);

      if (year !== oldYear) {
        this.currentYear = year;
      }
    }
  }
};

export default mixin;
